import styled from '@emotion/styled'
import { Button } from '@mui/material'

export const CollaboratorsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const CollaboratorsSectionTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #2a4365;
`

export const CollaboratorsCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  padding: 24px;
  background-color: #fff;
  border-radius: 16px;
  border: 2px solid rgba(42, 41, 92, 0.1);
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.16);
`

export const CollaboratorsContentRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

export const CollaboratorsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const CollaboratorsIcon = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fde2e2;
  border-radius: 8px;
  padding: 8px;
`

export const CollaboratorsIconImage = styled.img`
  width: 32px;
  height: 32px;
  display: block;
`

export const CollaboratorsInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const CollaboratorsTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #2a4365;
`

export const CollaboratorsTotal = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 16px;
  color: #2a4365;
`

export const CollaboratorsTotalLabel = styled.span`
  font-weight: 600;
`

export const CollaboratorsTotalValue = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #2a4365;
`

export const SkeletonTotalValue = styled.div`
  width: 48px;
  height: 20px;
  background: linear-gradient(
    90deg,
    #d8d8eb 25%,
    #f0f0f0 50%,
    #d8d8eb 75%
  );
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;

  @keyframes skeleton-loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`

export const CollaboratorsFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const CollaboratorsButton = styled(Button)`
  width: 348px;
  height: 48px;
  padding: 13px 71px;
  border-radius: 8px;
  border: 1px solid rgba(42, 41, 92, 0.08);
  background-color: #d96060;
  color: #fff;
  text-transform: none;
  font-size: 16px;
  font-weight: 600;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.16);
  white-space: nowrap;

  &:hover {
    background-color: #c75454;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.16);
  }

  &:disabled {
    background-color: #d96060;
    color: #fff;
    opacity: 0.7;
  }
`
